import {http} from '@/http'

export default {
  list(data, params) {
    return http.post('/areas/list', data, {params})
  },
  listAll() {
    return http.get('/areas')
  },
  changeStatus(id, status) {
    return http.put(`/areas/${id}/status`, null, {params: {status}})
  },
  save(data) {
    return http.post('/areas', data)
  },
  update(id, data) {
    return http.put(`/areas/${id}`, data)
  },
  get(id) {
    return http.get(`/areas/${id}`)
  },
  queryDni(dni) {
    return http.get(`/areas/dni/${dni}`)
  },
  download(data) {
    return http.post("/areas/xlsx", data, { responseType: "blob" });
  }
}
